var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"placeholder",class:{locked: _vm.locked, roundedCorners: _vm.selectedProductIsRounded}},[(!_vm.locked)?_c('PdfUploader',{attrs:{"control-style":"link","extra":{designId: _vm.designId},"allow-drag":false},on:{"upload":_vm.onUploadBack}},[_vm._v("+ back side")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54a9c9a6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/editor/EditorBackPlaceholder.vue
// module id = 3Jps
// module chunks = 1